import {isNaN} from 'lodash-es';

const SECONDS_IN_HOUR = 3600;
const SECONDS_IN_MINUTE = 60;

export const durationStr = /\d\d:[0-5]\d:[0-5]\d/;

export const msToHms = (duration: number): string => {
  if (!duration || isNaN(duration)) {
    return 'N/A';
  }

  return secondsToHms(duration / 1000);
};

export const secondsToHms = (duration: number): string => {
  if (!duration || isNaN(duration)) {
    return 'N/A';
  }

  const time = Math.abs(Math.round(duration));

  const hours = Math.floor(time / SECONDS_IN_HOUR);
  const minutes = Math.floor((time % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
  const seconds = time - (hours * SECONDS_IN_HOUR + minutes * SECONDS_IN_MINUTE);

  let hoursDisplay = `${hours}`;
  let minutesDisplay = `${minutes}`;
  let secondsDisplay = `${seconds}`;

  if (hoursDisplay.length === 1) {
    hoursDisplay = `0${hours}`;
  }

  if (minutesDisplay.length === 1) {
    minutesDisplay = `0${minutes}`;
  }

  if (secondsDisplay.length === 1) {
    secondsDisplay = `0${seconds}`;
  }

  return `${hoursDisplay}:${minutesDisplay}:${secondsDisplay}`;
};

export const HmsToSeconds = (duration: string): number => {
  if (!duration || duration.length !== 8 || !durationStr.test(duration)) {
    return 0;
  }

  let parsedDuration = 0;

  const [hours, minutes, seconds] = duration.split(':');

  parsedDuration += parseInt(seconds, 10);
  parsedDuration += parseInt(minutes, 10) * 60;
  parsedDuration += parseInt(hours, 10) * 3660;

  return parsedDuration;
};
